import * as Blockly from 'blockly-tradais';
import { javascriptGenerator } from 'blockly-tradais/javascript';

export const ConditionalFns = {
  customBlockForReturnBoolean() {
    Blockly.Blocks['return_boolean'] = {
      init(this: any) {
        this.appendValueInput('VALUE')
          .setCheck('Boolean')
          .appendField('return');
        this.setPreviousStatement(true, null);
        this.setColour('#5C81A6');
        this.setTooltip('Returns a boolean value from a Conditional Function. Must be the last block.');
        this.setHelpUrl('');
      }
    };

    (javascriptGenerator as any).forBlock['return_boolean'] = function (block: any) {
      const value =
        (javascriptGenerator as any).valueToCode(
          block,
          'VALUE',
          (javascriptGenerator as any).ORDER_NONE
        ) || 'false';
      return `return ${value};\n`;
    };
  }
};
